import { placeholderRelatedToVehicle } from './contentful-placeholders';

export const removeContentfulVehicleStrings = (list: string[]) =>
  list.filter(item => !item.includes(placeholderRelatedToVehicle));
